const ideas = [
  {
    id: 1,
    title: "One focal texture per room",
    image: "https://public.readdy.ai/ai/img_res/2915bd0688a09805383e2605799eb8da.jpg",
  },
  {
    id: 2,
    title: "Warm tones over cool whites",
    image: "https://readdy.ai/api/search-image?query=warm%20tone%20interior%20white%20cream%20ivory%20warm%20light%20living%20room%20natural%20wood%20floor%20minimal%20calm%20editorial%20photography%20beautiful%20neutral%20palette&width=640&height=480&seq=sg_idea2&orientation=landscape",
  },
  {
    id: 3,
    title: "Natural ceramics as quiet accents",
    image: "https://readdy.ai/api/search-image?query=natural%20ceramic%20pottery%20accents%20interior%20shelf%20minimal%20decor%20warm%20neutral%20tones%20beige%20cream%20editorial%20photography%20calm%20home%20styling%20high%20end&width=640&height=480&seq=sg_idea3&orientation=landscape",
  },
  {
    id: 4,
    title: "Open surfaces, purposeful objects",
    image: "https://readdy.ai/api/search-image?query=open%20surface%20minimal%20interior%20table%20shelf%20few%20chosen%20objects%20clear%20space%20purposeful%20decor%20neutral%20cream%20beige%20warm%20editorial%20photography%20high%20end%20home%20styling%20calm&width=640&height=480&seq=sg_idea4&orientation=landscape",
  },
];

export default function SGMinimalStylingSection() {
  return (
    <section className="py-28 bg-[#F5F1E8]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        {/* Header row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-end mb-16">
          <div>
            <div className="flex items-center gap-3 mb-7">
              <span
                className="text-[#D9CEBC] text-6xl leading-none"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700 }}
              >
                04
              </span>
              <span className="flex-1 h-px bg-[#C8BAA8]" />
            </div>

            <p
              className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Styling Ideas
            </p>

            <h2
              className="text-[#2C2825] text-3xl md:text-4xl leading-snug"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
            >
              Warm Minimal<br />
              <em>Styling Ideas</em>
            </h2>
          </div>

          <div className="flex flex-col justify-end gap-6">
            <p
              className="text-[#6B5E53] text-base leading-relaxed"
              style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
            >
              Minimal interiors with warmth, softness, and room to breathe.
              The goal is not emptiness — it is ease.
            </p>
            <div>
              <button
                className="inline-flex items-center gap-2 border border-[#C8BAA8] text-[#6B5E53] px-7 py-3 rounded-full text-xs tracking-[0.14em] hover:bg-[#2C2825] hover:text-white hover:border-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                View Styling Ideas
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-[10px]" />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Ideas grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {ideas.map((idea) => (
            <div key={idea.id} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl bg-[#EDE6DA] aspect-[4/3] mb-4">
                <img
                  src={idea.image}
                  alt={idea.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
              </div>
              <p
                className="text-[#2C2825] text-sm leading-snug group-hover:text-[#6B5E53] transition-colors"
                style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
              >
                {idea.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
